import { lazy } from "common/load/componentUtils";
import { Dialog } from "common/stackable/types";

import { CloseProp, useDialog, useDrawer } from "client/common/hooks/stackables";

import type { ReminderDeleteDialogProps } from "../components/ReminderDeleteDialog";
import type { ReminderDrawerProps } from "../components/ReminderDrawer";

const loadReminderDrawer = () => import("../components/ReminderDrawer");
const ReminderDrawer = lazy(loadReminderDrawer);

const loadReminderItemSelectDrawer = () => import("../components/ReminderItemSelectDrawer");
const ReminderItemSelectDrawer = lazy(loadReminderItemSelectDrawer);

const ReminderDeleteDialog = lazy(() => import("../components/ReminderDeleteDialog"));

export const useReminderDrawer = () => {
  const { open, closeAll } = useDrawer();
  return (props: ReminderDrawerProps & CloseProp): Dialog => ({
    open: () => open(ReminderDrawer, props),
    loader: () => {
      loadReminderDrawer();
    },
    closeAll,
  });
};

export const useReminderItemSelectDrawer = () => {
  const { open, closeAll } = useDrawer();
  return (props: CloseProp = {}): Dialog => ({
    open: () => open(ReminderItemSelectDrawer, props),
    loader: () => {
      loadReminderItemSelectDrawer();
    },
    closeAll,
  });
};

export const useReminderDeleteDialog = () => {
  const { open } = useDialog();
  return {
    open: (props: ReminderDeleteDialogProps & CloseProp) => open(ReminderDeleteDialog, props),
  };
};
